import { RootState } from "@redux/store";
import { useDispatch, useSelector } from "react-redux";

import {
  addAdicionalCost,
  addItem,
  clearCart,
  decreaseQuantity,
  increaseQuantity,
  removeItem,
  setDeliveryType,
} from "@redux/slice/cart";

const useCart = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state: RootState) => state.cart);

  const addToCart = (item: productType) => {
    let image = item.images[0]?.src;
    const length = item.images.length;
    if (length == 0) {
      image = process.env.BASE_IMAGE_URL;
    }

    const finalData = {
      id_product: item.id_product,
      name: item.name,
      code_in: item.code_in,
      price: item.price,
      quantity: 1,
      image: image,
    };
    dispatch(addItem(finalData));
  };

  const removeFromCart = (productId: number) => {
    dispatch(removeItem(productId));
  };

  /*  const updateItemQuantity = (productId: number, quantity: number) => {
    dispatch(updateQuantity({ id_product: productId, quantity }));
  }; */

  const emptyCart = () => {
    dispatch(clearCart());
    localStorage.removeItem("steep");
  };

  const increaseQuantityF = (productId: number) => {
    const item = cart.items.find((item) => item.id_product === productId);
    if (item) {
      dispatch(increaseQuantity(productId));
    }
  };
  const selectDeliveryType = (deliveryTypeId: number) => {
    if (deliveryTypeId) {
      dispatch(setDeliveryType(deliveryTypeId));
    }
  };
  const decreaseQuantityF = (productId: number) => {
    const item = cart.items.find((item) => item.id_product === productId);

    if (item && item.quantity > 1) {
      dispatch(decreaseQuantity(productId));
    } else {
      removeFromCart(productId);
    }
  };
  const handleAdiccionalCost = (cost: number) => {
    dispatch(addAdicionalCost(cost));
  };
  return {
    cart,
    addToCart,
    removeFromCart,
    increaseQuantityF,
    decreaseQuantityF,
    handleAdiccionalCost,
    emptyCart,
    selectDeliveryType,
  };
};

export default useCart;
